export const PAGE_LIMIT = 16
export const TRENDING_PAGE_LIMIT = 10
export const MORE_FROM_CREATOR_ASSET_COUNT = 6
export const SEARCH_DELAY = 500
export const DEFAULT_PRICE_RANGE = [0, 100]
export const ALTER_BODY_STATS = [
  { key: 'agility', value: 'Agility', range: [0, 100] },
  { key: 'strength', value: 'Strength', range: [0, 100] },
  { key: 'defense', value: 'Defense', range: [0, 100] },
  { key: 'sanity', value: 'Sanity', range: [0, 100] },
  { key: 'fame', value: 'Fame', range: [0, 100] },
]

export const CATEGORY_IMAGES = [
  {
    url: 'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/body_category.png',
    key: 'avatar',
  },
  {
    url: 'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/buildings_category.png',
    key: 'building',
  },
  {
    url: 'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/indoor_category.png',
    key: 'indoor',
  },
  {
    url: 'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/lands_category.png',
    key: 'land',
  },
  {
    url: 'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/names_category.png',
    key: 'name',
  },
  {
    url: 'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/structures_category.png',
    key: 'structure',
  },
  {
    url: 'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/outdoor_category.png',
    key: 'outdoor',
  },
]

export const CATEGORY_MENU_IMAGES = {
  avatar:
    'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/Menu/body_small.png',
  building:
    'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/Menu/buildings_small.png',
  indoor:
    'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/Menu/indoor_small.png',
  land: 'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/Menu/land_small.png',
  name: 'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/Menu/names_small.png',
  structure:
    'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/Menu/structures_small.png',
  outdoor:
    'https://storage.googleapis.com/pokerx-6c898.appspot.com/Categories/Menu/outdoor_small.png',
}
